import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { ArrowLeft, CreditCard, Clock, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const RetraitsDepots = () => {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link
            to="/guides"
            data-discover="true"
            className="inline-flex items-center text-toxic-green hover:text-opacity-80 mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour aux guides
          </Link>

          <article className="bg-dark-card border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Retraits et Dépôts
            </h1>

            <div className="prose prose-invert max-w-none">
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Dépenser et retirer de l'argent sur une plateforme de paris en ligne devrait être simple et rapide. Pourtant, les méthodes disponibles, les délais, les limites et les conditions varient considérablement d'une plateforme à l'autre. Comprendre ces différences vous permet de choisir la plateforme qui correspond à vos besoins et d'éviter les surprises désagréables.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Méthodes de Dépôt
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                La carte bancaire (Visa, Mastercard) est la méthode la plus courante et généralement la plus rapide. Les dépôts sont généralement instantanés, et la plupart des plateformes n'appliquent pas de frais. C'est l'option la plus simple pour la plupart des parieurs. Cependant, certaines banques bloquent les transactions vers les sites de paris - si c'est votre cas, vous devrez utiliser une autre méthode.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Le virement bancaire est plus lent (1 à 3 jours ouvrables) mais souvent sans limite de montant. C'est idéal pour les gros dépôts. Les portefeuilles électroniques (PayPal, Skrill, Neteller) offrent un bon compromis : dépôts rapides, couche de sécurité supplémentaire, et souvent des promotions exclusives. Certains portefeuilles offrent même des bonus sur les dépôts.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les cartes prépayées (Paysafecard) permettent de déposer sans révéler vos informations bancaires, mais elles ont souvent des limites de montant et ne permettent généralement pas de retirer. Les cryptomonnaies commencent à être acceptées par certaines plateformes, offrant anonymat et rapidité, mais elles restent minoritaires.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Limites de Dépôt
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Chaque méthode de dépôt a ses propres limites, et chaque plateforme peut imposer des limites supplémentaires. Les cartes bancaires ont généralement des limites quotidiennes (souvent 1000€ à 5000€) et mensuelles. Les virements bancaires ont souvent des limites plus élevées ou inexistantes. Les portefeuilles électroniques varient selon le type de compte.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Si vous prévoyez de déposer des montants importants, vérifiez les limites avant de créer un compte. Certaines plateformes permettent d'augmenter les limites après vérification d'identité ou pour les comptes VIP, mais cela peut prendre du temps. Pour les gros parieurs, les limites peuvent être un facteur déterminant dans le choix de la plateforme.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Méthodes de Retrait
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                La plupart des plateformes exigent que vous retiriez par la même méthode que vous avez utilisée pour déposer, au moins pour le montant initial. C'est une mesure de sécurité anti-blanchiment. Si vous avez déposé 500€ par carte bancaire et gagné 2000€, vous devrez retirer 500€ sur votre carte, et vous pourrez retirer le reste par une autre méthode.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les retraits par carte bancaire prennent généralement 1 à 3 jours ouvrables. Les virements bancaires prennent 2 à 5 jours ouvrables. Les portefeuilles électroniques sont souvent les plus rapides, avec des retraits parfois instantanés ou en 24 heures. C'est un avantage important si vous avez besoin d'accéder rapidement à vos gains.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certaines plateformes offrent des retraits express (généralement payants) qui permettent de recevoir vos fonds en quelques heures. C'est pratique mais coûteux - évaluez si la rapidité vaut le coût supplémentaire.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Limites de Retrait
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les limites de retrait peuvent être plus contraignantes que les limites de dépôt. Beaucoup de plateformes imposent des limites quotidiennes (souvent 2000€ à 5000€), hebdomadaires (5000€ à 10000€), et mensuelles (10000€ à 50000€). Pour les gros gagnants, ces limites peuvent être frustrantes.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certaines plateformes permettent d'augmenter les limites pour les comptes vérifiés ou VIP. D'autres offrent des limites plus élevées par défaut. Si vous prévoyez de gagner gros, vérifiez ces limites avant de vous engager. Rien n'est plus frustrant que de gagner 50000€ et de devoir attendre plusieurs mois pour tout retirer.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les limites peuvent aussi varier selon la méthode de retrait. Les virements bancaires ont souvent des limites plus élevées que les cartes bancaires. Les portefeuilles électroniques varient selon le type de compte.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Les Frais de Transaction
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                La plupart des plateformes agréées n'appliquent pas de frais sur les dépôts, quelle que soit la méthode. C'est la norme, et si une plateforme facture des frais de dépôt, c'est un point négatif à considérer. Pour les retraits, c'est plus variable.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Beaucoup de plateformes offrent un ou deux retraits gratuits par mois, puis facturent des frais (généralement 2€ à 5€) pour les retraits supplémentaires. D'autres offrent des retraits illimités gratuits. Les retraits express sont presque toujours payants, souvent 10€ à 25€.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Les portefeuilles électroniques peuvent facturer leurs propres frais de retrait vers votre compte bancaire. Vérifiez ces frais avant de choisir une méthode. Sur le long terme, même de petits frais peuvent s'accumuler.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                La Vérification d'Identité
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Toutes les plateformes agréées doivent vérifier votre identité avant de permettre les retraits. C'est une obligation légale de lutte contre le blanchiment d'argent. La vérification consiste généralement à fournir une pièce d'identité (carte d'identité ou passeport) et un justificatif de domicile (facture récente).
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Certaines plateformes permettent de commencer à parier avant la vérification, mais bloquent les retraits jusqu'à ce qu'elle soit complète. D'autres exigent la vérification avant même le premier dépôt. Dans tous les cas, faites-la dès que possible pour éviter les délais quand vous voudrez retirer.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                La vérification prend généralement 24 à 48 heures une fois les documents soumis. Si elle prend plus de temps, contactez le service client. Des retards peuvent indiquer un problème avec vos documents ou un problème technique.
              </p>

              <h2 className="text-3xl font-bold mt-12 mb-6 text-white">
                Choisir la Bonne Méthode
              </h2>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour la plupart des parieurs, la carte bancaire est le choix le plus simple : dépôts instantanés, retraits rapides, pas de frais supplémentaires. Si vous préférez la sécurité supplémentaire ou si votre banque bloque les transactions, un portefeuille électronique est une bonne alternative.
              </p>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Pour les gros montants, le virement bancaire peut être nécessaire malgré sa lenteur. Pour l'anonymat, les cartes prépayées ou les cryptomonnaies (si disponibles) sont des options, mais avec des limitations.
              </p>

              <div className="bg-toxic-green/10 border border-toxic-green/30 rounded-xl p-6 mt-12">
                <h3 className="text-2xl font-bold mb-4 text-white flex items-center">
                  <CreditCard className="w-6 h-6 text-toxic-green mr-3" />
                  Points à Vérifier
                </h3>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Vérifiez les limites de dépôt et de retrait avant de créer un compte</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Comprenez les délais de retrait pour chaque méthode</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Vérifiez les frais de transaction, surtout pour les retraits</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Complétez la vérification d'identité dès que possible</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-toxic-green mr-2">•</span>
                    <span>Choisissez une méthode qui correspond à vos besoins de rapidité et de sécurité</span>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RetraitsDepots;

